{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Financing",
  "description": "Create a package of subscription documents for a financing",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "company": { "$ref": "#/definitions/company" },
    "investor": { "$ref": "#/definitions/investor" },
    "commitment": { "$ref": "#/definitions/commitment" }
  },
  "additionalProperties": false
}
